import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import PcsList from "./pcs/list/PcsList";
import PcsDetail from "./pcs/detail/PcsDetail";
import PcsCreate from "./pcs/create/PcsCreate";

export default function Purchase() {
    const { key } = useLocation()

    return <Routes>
        <Route key={key} path={"pcs/list"} element={<PcsList />} />
        <Route key={key} path={"pcs/detail/:id"} element={<PcsDetail />} />
        <Route key={key} path={"pcs/create"} element={<PcsCreate />} />
        <Route key={key} path={"delivery/list"} element={<PcsList isPcsDelivery />} />
        <Route key={key} path={"delivery/detail/:id"} element={<PcsDetail isPcsDelivery />} />
        {/* NOTE: 외부 채권 */}
        {/*<Route key={key} path={"bond/list"} element={<>BondList</>}/>*/}
        {/*<Route key={key} path={"bond/detail/:id"} element={<>BondDetail</>}/>*/}
        <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
    </Routes>
}